// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__gvaku","copy":"styles_copy__zIqU7"};